import { useMemo } from 'react'
import { useFestivalLineupQuery } from '@mwxltd/flix-api-client'
import { getNextFilmFromLineup } from '../getters'

export const useNextLineupFilm = (currentFilm = {}) => {
  const {
    data: { films: lineupFilms },
  } = useFestivalLineupQuery()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(
    () => getNextFilmFromLineup(lineupFilms, currentFilm),
    [lineupFilms, currentFilm.id, currentFilm.slug],
  )
}
